import type { FC } from "react";
import { css, cx } from "@stubhub/broadway-foundation/css";
import { ClockIcon } from "@stubhub/broadway-web/icons/functional";

const theaterRuntimeWrapper = css({
  display: "flex",
  color: "text",
  textStyle: "body.small",
  "& > svg": {
    display: "block",
    minWidth: "primitives.250",
    marginInlineEnd: "primitives.100",
  },
});

interface Props {
  /** Duration string for the show */
  durationString: string;
  /** used to wrap in styled component */
  className?: string;
}

/** Component that renders the theater duration portion for Performer Info Card */
export const TheaterRuntime: FC<Props> = ({ durationString, className }) => (
  <div className={cx(theaterRuntimeWrapper, className)}>
    <ClockIcon size={20} />

    <span> {durationString}</span>
  </div>
);
